import {apiClient} from "./apiClient";
import {TipoDescanso} from "../types/tiposDescanso";

const api = () => apiClient('/cronograma/descansos')

export function getTiposDescanso() {
    return api().get<TipoDescanso[]>('/tipos');
}
